import { render, staticRenderFns } from "./ContractList.vue?vue&type=template&id=5b673d00&scoped=true&lang=pug"
import script from "./ContractList.vue?vue&type=script&lang=js"
export * from "./ContractList.vue?vue&type=script&lang=js"
import style0 from "./ContractList.vue?vue&type=style&index=0&id=5b673d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b673d00",
  null
  
)

export default component.exports